import React from "react";
import useUpdateCompanyDepartmentModal from "./useUpdateCompanyDepartmentModal";
import CompanyDepartmentFormModal from "./CompanyDepartmentFormModal";
import Resources from "../../types/Resources";

export type UpdateCompanyDepartmentModalProps = {
    departmentId: number;
    resources: Resources;
    show: boolean;
    canManageIsEnergyHarbourCustomer: boolean;
    onDepartmentUpdated: (updatedDepartmentId: number) => void;
    onHide: () => void;
};

function UpdateCompanyDepartmentModal(props: UpdateCompanyDepartmentModalProps) {
    const modalContent = useUpdateCompanyDepartmentModal(props);

    return (
        <CompanyDepartmentFormModal
            formState={modalContent.formState}
            onNameChange={modalContent.handleNameChange}
            onIsEnergyHarbourCustomerChange={modalContent.handleIsEnergyHarbourCustomerChange}
            canManageIsEnergyHarbourCustomer={props.canManageIsEnergyHarbourCustomer}
            onSubmit={modalContent.handleSubmitAsync}
            disableSubmit={modalContent.disableSubmit}
            modalHeader={props.resources.get("UpdateCompanyDepartment") ?? ""}
            onHide={props.onHide}
            show={props.show}
            resources={props.resources}
            isLoading={modalContent.isLoading}
        />
    );
}

export default UpdateCompanyDepartmentModal;
